import { requireAuth } from '@/router/helpers';

const FeRoutes = [
  {
    path: '/forms',
    name: 'FormIndexPage',
    component: () => import('@/views/Forms/Index.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/forms/*',
    name: 'FormViewPage',
    component: () => import('@/views/Forms/View'),
    beforeEnter: requireAuth,
  },
];

const AdminRoutes = [
  // categories - first because of precedence of subcat
  {
    path: '/admin/eforms/categories',
    name: 'AdminFormCategoriesIndexPage',
    component: () => import('@/views/Forms/categories/admin/Index.vue'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/eforms/category/create',
    name: 'AdminFormCategoriesCreatePage',
    components: {
      default: () => import('@/views/Forms/categories/admin/Index.vue'),
      panel: () => import('@/views/Forms/categories/admin/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: true, openPanel: true },
  },
  {
    path: '/admin/eform/:id/edit/:versionId',
    name: 'AdminFormVersionPreview',
    component: () => import('@/views/Forms/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/eforms/category/:id/edit',
    name: 'AdminFormCategoriesEditPage',
    components: {
      default: () => import('@/views/Forms/categories/admin/Index.vue'),
      panel: () => import('@/views/Forms/categories/admin/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: true, openPanel: true },
  },
  // forms
  {
    path: '/admin/eforms',
    name: 'AdminFormIndexPage',
    component: () => import('@/views/Forms/admin/Index.vue'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/eforms/:status',
    name: 'AdminFormStatusIndexPage',
    component: () => import('@/views/Forms/admin/Index.vue'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/eform/create',
    name: 'AdminFormCreatePage',
    component: () => import('@/views/Forms/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/eform/:id/edit',
    name: 'AdminFormEditPage',
    component: () => import('@/views/Forms/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/eform/:id/view',
    name: 'AdminFormEntriesPage',
    component: () => import('@/views/Forms/admin/Entries'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
];

export default [...FeRoutes, ...AdminRoutes];
